import ApiHandler from './ApiHandler';

export default {
    // Get all social links for a user
    getSocialLinks: userId => ApiHandler.get(`/social-links/${userId}`),

    // Get a single social link
    getSocialLink: (userId, socialLinkId) =>
        ApiHandler.get(`/social-links/${userId}/${socialLinkId}`),

    // Create a new social link
    createSocialLink: (userId, data) =>
        ApiHandler.post(`/social-links/${userId}`, data),

    // Update an existing social link
    updateSocialLink: (userId, socialLinkId, data) =>
        ApiHandler.put(`/social-links/${userId}/${socialLinkId}`, data),

    // Delete a social link
    deleteSocialLink: (userId, socialLinkId) =>
        ApiHandler.delete(`/social-links/${userId}/${socialLinkId}`)
};
